export default __webpack_public_path__ + "static/media/4.3b03a48d.png";